import $ from "jquery";
import Operation from "core/models/Operation";
import OperationSet from "core/models/OperationSet";
import GroupCollection from "app/models/GroupCollection";
import SecurityEditor from "app/views/admin/permissions/Editor";
import Field from "core/models/Field";
import Layout from "app/models/Layout";
import FormView from "core/views/FormView";
import ServiceSelector from "app/views/map/ServiceSelector";
import _ from "underscore";
import MapServiceCollection from "app/models/MapServiceCollection";
import session from "app/Session";
import modals from "core/views/modals";
import isMobile from "core/is-mobile";
var modifyLayout = function (model) {
  var deferred = new $.Deferred();
  var fields = [
    new Field(Layout.fields["name"]),
    new Field(Layout.fields["description"]),
  ];
  var title = "Edit Layout",
    action = "Save",
    message = "Layout updated";

  if (model.isNew()) {
    title = "Create Layout";
    action = "Create";
    message = "Layout created";
  }

  var formView = new FormView({
    model: model,
    fields: fields,
  });

  formView.render();
  model.storeConfiguration();

  modals.confirm(
    title,
    formView.$el,
    {
      type: "primary",
      text: action,
    },
    function () {
      formView
        .save(true)
        .done(function () {
          deferred.resolve(model, message);
        })
        .fail(function (err) {
          deferred.reject(err);
        });
    }
  );

  return deferred.promise();
};

export default new OperationSet([
  new Operation({
    id: "edit-security",
    text: "Edit Security",
    icon: "lock",
    action: function (model) {
      //manage layout security
      var deferred = new $.Deferred();
      var type = {
        LayerConfiguration: model.id,
      };
      var actions = {
        read: "View the layout.",
        delete: "Delete the layout.",
        update: "Update properties of the layout, including security.",
      };
      var groups = new GroupCollection([]);

      groups.fetch({
        success: function () {
          var editor = new SecurityEditor({
            groups: groups.models,
            type: type,
            actions: actions,
            allowAllUsers: true,
          });

          editor.render();
          modals.alert(
            "Manage Security",
            editor.$el,
            "Done",
            function () {
              deferred.resolve(model);
            },
            "Cancel",
            function () {
              deferred.reject(false);
            }
          );
        },
        error: function (collection, response) {
          deferred.reject(response);
        },
      });

      return deferred.promise();
    },
    available: function (model) {
      return (
        !model.isNew() &&
        session.can(["update", "own"], {
          LayerConfiguration: model,
        })
      );
    },
  }),
  new Operation({
    id: "save-layout",
    text: "Save Layout",
    icon: "floppy-disk",
    action: function (model) {
      //be sure to handle new layer configurations here, too
      var deferred = new $.Deferred();

      var continueProcessing = function (model) {
        if (model.isNew()) {
          modifyLayout(model)
            .done(function (model, message) {
              deferred.resolve(model, message);
            })
            .fail(function (error) {
              deferred.reject(error);
            });
        } else {
          model.storeConfiguration();
          model.save(null, {
            success: function () {
              deferred.resolve(model, "Layer list saved");
            },
            error: function (model, response) {
              deferred.reject(response);
            },
          });
        }
      };

      if (
        session.can(["update", "own"], {
          LayerConfiguration: model,
        })
      ) {
        continueProcessing(model);
      } else {
        modals.confirm(
          "Insufficient Privileges",
          "You are not allowed to save this layout. Would you like to create a new layout instead?",
          {
            type: "primary",
            text: "Yes",
          },
          function () {
            var finalModel = model.clone();

            finalModel.set("name", Layout.DefaultName(session));

            continueProcessing(finalModel);
          },
          "No"
        );
      }

      return deferred.promise();
    },
    available: function (model) {
      return (
        session.can(["update", "own"], {
          LayerConfiguration: model,
        }) || session.can("create", "LayerConfiguration")
      );
    },
  }),
  new Operation({
    id: "create-layout",
    text: "Create Layout",
    icon: "plus",
    action: function (model) {
      var finalModel = model;

      if (!model.isNew()) {
        finalModel = model.clone();
      }

      return modifyLayout(finalModel);
    },
    available: function () {
      return session.can("create", "LayerConfiguration");
    },
  }),
  new Operation({
    id: "edit-layout",
    text: "Edit Layout Details",
    icon: "pencil",
    action: function (model) {
      return modifyLayout(model);
    },
    available: function (model) {
      return (
        !model.isNew() &&
        session.can(["update", "own"], {
          LayerConfiguration: model,
        })
      );
    },
  }),
  new Operation({
    id: "delete-layout",
    text: "Delete Layout",
    icon: "trash",
    action: function (model) {
      var deferred = new $.Deferred();

      modals.confirm(
        "Delete Layout",
        "Are you sure you want to delete this layout?",
        {
          type: "danger",
          text: "Delete",
        },
        function () {
          model.destroy({
            success: function () {
              deferred.resolve(
                Layout.CreateDefault([]),
                "Layout deleted successfully."
              );
            },
            error: function (model, response) {
              deferred.reject(response);
            },
          });
        },
        "Cancel",
        function () {
          deferred.reject(false);
        }
      );

      return deferred.promise();
    },
    available: function (model) {
      return (
        !model.isNew() &&
        session.can(["delete", "own"], {
          LayerConfiguration: model,
        })
      );
    },
  }),
  new Operation({
    id: "add-service",
    text: "Add Service",
    icon: "tree-deciduous",
    action: function (model) {
      //present a dialog from which the user can either create a new group or select an existing group
      //for our purposes, a "group" is a MapServiceBase implementation
      var services = new MapServiceCollection([]);
      var deferred = new $.Deferred();

      services.fetch({
        success: function () {
          ServiceSelector.selectService(
            model.serviceLayers,
            services.models,
            {
              confirmText: {
                type: "primary",
                text: "Select",
              },
              title: "Add Service",
              canCreate: session.can("create", "MapService") && !isMobile,
            },
            function (err, serviceLayer) {
              if (err) {
                if (_.isBoolean(err)) {
                  return deferred.reject(false);
                } else {
                  return deferred.reject(err);
                }
              }

              //flash.info('Loading service data.<img src="' + HtmlUtils.url('/images/ajax-loader-blue.gif') + '" height="32" width="32"></img>', true);
              deferred.notify(model, "Loading service data");
              model
                .addService(serviceLayer)
                .done(function () {
                  deferred.resolve(model, "Service added successfully.");
                })
                .fail(function (err) {
                  deferred.reject(err);
                });
            }
          );
        },
        error: function (collection, response) {
          deferred.reject(response);
        },
      });

      return deferred.promise();
    },
  }),
  new Operation({
    id: "clear-selection",
    text: "Clear Selection",
    icon: "fire",
    action: function (model) {
      _.each(model.serviceLayers, function (serviceLayer) {
        serviceLayer.eachLayer(function (layer) {
          layer.unhighlight();
        });
      });
      model.workingLayer.unhighlight();

      return Operation.resolve(model);
    },
  }),
]);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/operations/map/LayoutOperations.js
// module id = 883
// module chunks = 1